export const DASHBOARD_MODES = [
  { id: 'finance', label: 'Financeiro' },
  { id: 'operations', label: 'Gestão da operação' },
  { id: 'activity', label: 'Movimentações' },
];

export function availableDashboardModes(role, policy = {}, traffic = {}) {
  if (!['admin', 'reseller'].includes(role)) return [];
  if (role === 'admin') return traffic?.preview_available === true
    ? [...DASHBOARD_MODES, { id: 'traffic', label: 'Gestão de tráfego' }]
    : DASHBOARD_MODES;
  return DASHBOARD_MODES.filter(({ id }) => id === 'finance'
    ? policy.kpi !== false || policy.growth !== false
    : (id === 'activity' ? ['kpi','growth','infra','iptv','quickActions'] : ['kpi', 'infra', 'iptv', 'quickActions']).some((key) => policy[key] !== false));
}

export function resolveDashboardMode(requested, preferred, available) {
  const ids = available.map(({ id }) => id);
  return [requested, preferred, 'finance', 'operations'].find((id) => ids.includes(id)) || null;
}

// The server still stores the historic mode identifiers. Only their presentation
// is unified: a saved `activity` preference remains valid without a profile write.
export function dashboardWorkspaceMode(mode) {
  return mode === 'activity' ? 'operations' : mode;
}

export function dashboardPresentationModes(available) {
  const operational = available.find(({ id }) => id === 'operations')
    || available.find(({ id }) => id === 'activity');
  return available.filter(({ id }) => id !== 'activity' && id !== 'operations')
    .concat(operational ? [{ ...operational, label: 'Operação e movimentações' }] : [])
    .sort((a, b) => ['finance', 'operations', 'activity', 'traffic'].indexOf(a.id)
      - ['finance', 'operations', 'activity', 'traffic'].indexOf(b.id));
}

export function loginLandingPage(role) {
  // /dashboard resolves the saved preference. Never accept an arbitrary redirect.
  return role === 'attendant' ? '/chats' : '/dashboard';
}
